<template>
  <div style="height: 100vh">
    <KeyboardEvents @keyup="keyboardEvent" />
    <loading
      :active.sync="$store.getters.isLoading"
      :can-cancel="false"
      :height="32"
      :is-full-page="true"
      :width="32"
    />

    <!-- /.login-logo -->
    <b-row
      class="h-100"
      style="background: #f4f6f9"
    >
      <b-col
        align-self="center"
        lg="4"
        md="12"
      >
        <div class="login-div">
          <div class="login-logo mb-3">
            <img
              alt="TENACY"
              class="logo-login-img"
              :src="`${publicPath}static/img/Tenacy_couleur_borderless.svg`"
            />
          </div>

          <NdsMarkdownViewer
            v-if="policy_password"
            :value="policy_password"
          />
          <form
            v-if="valid_token"
            @submit.prevent.stop="$emit('dummy')"
          >
            <FormField
              ref="password"
              v-model="passwordInput"
              :error="passwordError"
              name="password"
              no-check
              :placeholder="_('New password')"
              type="password"
              @blur="passwordOnBlur"
            />

            <FormField
              v-model="passwordConfirmInput"
              :error="passwordConfirmError"
              name="password_confirm"
              no-check
              :placeholder="_('Confirm new password')"
              type="password"
              @blur="passwordConfirmOnBlur"
            />

            <div class="row">
              <div class="col-12">
                <b-button
                  ref="sign_in"
                  class="w-100 login-button tenacy-btn ripple"
                  variant="primary"
                  @click.stop="setPassword"
                >
                  <translate>Set password</translate>
                </b-button>
              </div>
            </div>
          </form>
          <p
            v-if="!valid_token && processed_token"
            class="mb-2 text-center text-danger"
          >
            <translate>Invalid token</translate>
          </p>
          <b-row class="mt-3">
            <b-col class="text-center">
              <a
                href="#"
                @click="$router.push({ path: '/login' })"
              >
                <translate>Sign in</translate>
              </a>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <AuthColRight class="hide-col" />
    </b-row>
  </div>
</template>

<script>
import { useRoute } from 'vue-router/composables'
import Loading from 'vue-loading-overlay'
import FormField from '@/components/ui/FormField.vue'
import UnauthPageMixin from '@/mixins/UnauthPageMixin'
import KeyboardEvents from '@/components/ui/KeyboardEvents.vue'
import AuthColRight from '@/components/ui/AuthColRight.vue'
import { config } from '@/config.settings'
import NdsMarkdownViewer from '@/components/NewDesignSystem/NdsMarkdown/NdsMarkdownViewer.vue'
import { useFormValidation } from '@/contexts/shared/form-validation/UseFormValidation.composables'
import { ValidateOn } from '@/contexts/shared/form-validation/FormValidation.interfaces'
import {
  passwordSchema,
  passwordConfirmSchema,
  passwordResetFormSchema,
} from '@/components/unauth-pages/PasswordResetView.helpers'

export default {
  name: 'PasswordResetView',
  components: {
    NdsMarkdownViewer,
    KeyboardEvents,
    AuthColRight,
    FormField,
    Loading,
  },
  mixins: [UnauthPageMixin],
  setup() {
    const route = useRoute()

    const {
      validators: {
        password: { input: passwordInput, error: passwordError, onBlur: passwordOnBlur },
        password_confirm: { input: passwordConfirmInput, error: passwordConfirmError, onBlur: passwordConfirmOnBlur },
      },
      validate,
      valid,
    } = useFormValidation(
      {
        password: {
          schema: passwordSchema(route.params.token),
          value: '',
        },
        password_confirm: {
          schema: passwordConfirmSchema(),
          value: '',
        },
      },
      {
        validateOn: ValidateOn.BLUR,
        formSchema: passwordResetFormSchema(),
      }
    )

    return {
      passwordInput,
      passwordError,
      passwordOnBlur,
      passwordConfirmInput,
      passwordConfirmError,
      passwordConfirmOnBlur,
      validateForm: validate,
      isFormValid: valid,
    }
  },
  data: function () {
    return {
      valid_token: false,
      processed_token: false,
      recaptca_enabled: false,
      policy_password: '',
      publicPath: import.meta.env.BASE_URL,
    }
  },
  mounted() {
    const _this = this
    this.$store.commit('loading')
    this.$http
      .post(config.base_url + '/auth/password/check_reset_token', {
        token: this.$route.params.token,
      })
      .then((resp) => {
        _this.processed_token = true
        if (resp.data.ok) {
          this.$http
            .get(config.base_url + '/user/password_policy?token=' + this.$route.params.token)
            .then((resp) => {
              if (resp.data.ok) {
                _this.policy_password = resp.data.object
              } else {
                throw new Error()
              }
            })
            .catch((err) => {
              _this.$log.debug(err)
            })
          _this.$store.commit('unloading')
          _this.valid_token = true
        } else {
          throw new Error(resp.data.message)
        }
      })
      .catch((err) => {
        _this.processed_token = true
        _this.$store.commit('unloading')
        _this.$toast.alert(err.message)
      })
  },
  methods: {
    setPassword: async function () {
      const _this = this

      await this.validateForm()
      if (!this.isFormValid) {
        return
      }

      this.$store.commit('loading')
      this.$http
        .post(config.base_url + '/auth/password/reset', {
          token: this.$route.params.token,
          password: this.passwordInput,
          password_confirm: this.passwordConfirmInput,
        })
        .then((resp) => {
          if (resp.data.ok) {
            _this.$store.commit('unloading')
            _this.$router.push({ path: '/login' })
            _this.$toast.info(resp.data.message)
          } else {
            throw new Error(resp.data.message)
          }
        })
        .catch((err) => {
          _this.$store.commit('unloading')
          _this.$log.debug(err)
          _this.$toast.alert(err)
        })
    },
    keyboardEvent(e) {
      if (e.which === 13) {
        this.setPassword()
      }
    },
  },
}
</script>
